import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle, withState } from 'recompose';
import { Trans } from 'react-i18next';
import i18next from 'i18next';


import Table from '../../common/table';
import { Pagination, SelectItemsPerPage } from '../../common';
import { ITEMS_PER_PAGE } from '../../../constants/pagination';
import { companyActions } from '../../../../modules/company';

import { NavTabs, NavTabsBtn, NavWrapS, TotalPages, TotalPagesCount } from '../companies/companiesS';

import {
  SelectCheck,
  VerifiedDrop,
  VerifiedDropItem,
  VerifiedIconArrow,
  VerifiedIconCheck,
  VerifiedIconCheckWrap,
  VerifiedItem,
  VerifiedSelect,
  VerifiedText
} from './companyStatusesS';

export const VerifySelect = compose(
  connect(null, {
    updateVerifiedCompany: companyActions.updateVerifiedCompany
  }),
  withState('isDropdownOpen', 'setDropdownOpen', false),
  withState('selectedOption', 'setSelectedOption', ({ company }) => company.verified
    ? i18next.t('adminPanel.statuses.buttons.verifiedStatuses')
    : i18next.t('adminPanel.statuses.buttons.notVerifiedStatuses')),
  lifecycle({
    componentDidUpdate(prevProps) {
      if (prevProps.isOpen !== this.props.isDropdownOpen && this.props.isDropdownOpen) {
        document.addEventListener('click', () => {
          this.props.setDropdownOpen(false)
        }, {
          once: true
        })
      }
    }
  })
)( ({ company, updateVerifiedCompany, isDropdownOpen, setDropdownOpen, selectedOption }) => (
   <VerifiedSelect>
    <VerifiedItem
      active={isDropdownOpen}
      onClick={() => setDropdownOpen(!isDropdownOpen)}
    >
      <VerifiedIconCheckWrap bgColor={selectedOption  === i18next.t('adminPanel.statuses.buttons.verifiedStatuses') && "checkVerification"}>
        <VerifiedIconCheck icon="check"/>
      </VerifiedIconCheckWrap>
      <VerifiedText>{selectedOption}</VerifiedText>
      <VerifiedIconArrow
        icon="angle-down"
      />
    </VerifiedItem>
    {isDropdownOpen && <VerifiedDrop>
      <VerifiedDropItem onClick={() => updateVerifiedCompany(company._id, STATUSES_STATE.VERIFIED)}>
        <VerifiedIconCheckWrap bgColor="checkVerification">
          <VerifiedIconCheck icon="check"/>
        </VerifiedIconCheckWrap>
        <VerifiedText><Trans i18nKey="adminPanel.statuses.buttons.verifiedStatuses"/></VerifiedText>
        {selectedOption  === i18next.t('adminPanel.statuses.buttons.verifiedStatuses') && <SelectCheck icon="check" />}
      </VerifiedDropItem>
      <VerifiedDropItem onClick={() => updateVerifiedCompany(company._id, STATUSES_STATE.NOT_VERIFIED)}>
        <VerifiedIconCheckWrap>
          <VerifiedIconCheck icon="check"/>
        </VerifiedIconCheckWrap>
        <VerifiedText><Trans i18nKey="adminPanel.statuses.buttons.notVerifiedStatuses"/></VerifiedText>
        {selectedOption  === i18next.t('adminPanel.statuses.buttons.notVerifiedStatuses') && <SelectCheck icon="check" />}
      </VerifiedDropItem>
    </VerifiedDrop>}
  </VerifiedSelect>
));

export const STATUSES_STATE = {
  ALL: 'all',
  VERIFIED: 'true',
  NOT_VERIFIED: 'false'
};

const tabsBtn = [
  {filterName: STATUSES_STATE.ALL, textKey: 'adminPanel.statuses.buttons.activeStatues'},
  {filterName: STATUSES_STATE.VERIFIED, textKey: 'adminPanel.statuses.buttons.verifiedStatuses'},
  {filterName: STATUSES_STATE.NOT_VERIFIED, textKey: 'adminPanel.statuses.buttons.notVerifiedStatuses'}
];

const CompanyStatusesComponent = ({
  statusesColumns,
  companies,
  statusesStateType,
  setStatusesStateType,
  itemsPerPage,
  setItemsPerPage,
  amount,
  page,
  setPage,
  location,
  push
}) => (
  <>
    <NavTabs aItems="center">
      {tabsBtn.map(({filterName, textKey}) => (
        <NavTabsBtn
          key={filterName}
          fz="mediumText"
          padding="6px 15px"
          fontFamily="normal"
          onClick={() => {
            setStatusesStateType(filterName);
            push(location.pathname, filterName === STATUSES_STATE.ALL ? null : { verified: filterName });
          }}
          active={filterName === statusesStateType}
        >
          <Trans i18nKey={textKey}/>
        </NavTabsBtn>
      ))}
    </NavTabs>

    <Table
      columns={statusesColumns}
      data={companies}
      maxWidth="800px"
    />

    <NavWrapS aItems="center" justify="space-between" width="800px" >

      <SelectItemsPerPage
        options={Object.values(ITEMS_PER_PAGE)}
        itemsPerPage={itemsPerPage}
        onChangeItemsPerPage={changedTo => setItemsPerPage(changedTo)}
      />

      <Pagination
        itemsPerPage={itemsPerPage}
        itemsAmount={amount}
        pageToRender={page}
        setPage={setPage}
      />

      <TotalPages>
        <Trans i18nKey="adminPanel.companies.totalCompany"/>
        <TotalPagesCount>{amount}</TotalPagesCount>
      </TotalPages>
    </NavWrapS>
  </>
);

export default CompanyStatusesComponent;
